<!--
 * @Author: xionglinlin
 * @LastEditTime: 2023-09-25 11:00:00
 * @Description: 角色管理
-->
<template>
  <div>
    <el-card
      class="absolute angle-mgt w-468px z-99 text-white p-10px right-25px"
      :style="{
        height: location.height,
        top: location.top,
        right: location.float === 'right' ? '25px' : '',
        left: location.float === 'left' ? '25px' : '',
      }"
    >
      <div slot="header" class="flex justify-between items-center">
        <span class="text-14px">视角管理</span>
        <div class="flex items-center">
          <el-tooltip content="导出" :open-delay="1000" effect="light">
            <el-button
              type="success"
              size="mini"
              class="iconfont icon-line-download"
              @click="exportExcel"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="导入视角" :open-delay="1000" effect="light">
            <el-button
              type="success"
              size="mini"
              class="iconfont icon-line-upload"
              @click="uploadExcel"
            ></el-button>
          </el-tooltip>
          <el-dropdown class="ml-10px">
            <span class="el-dropdown-link">
              <i class="iconfont icon-line-moreHorizontal font-bold"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="operateTree(true)">展开全部</el-dropdown-item>
              <el-dropdown-item @click.native="operateTree(false)">收起全部</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span
            class="ml-20px iconfont icon-line-close float-right cursor-pointer text-12px"
            @click="closeComponent"
          ></span>
        </div>
      </div>
      <div class="flex h-38px p-5px mt-5px mb-5px">
        <el-input
          class="flex-1 mr-10px"
          placeholder="搜索名称"
          v-model="keyWord"
          clearable
          @keyup.enter.native="getTreeData"
        ></el-input>
        <el-button type="primary" size="mini" @click="getTreeData" class="!h-36px">搜索</el-button>
        <el-button size="mini" type="primary" class="!h-36px" @click="handleTreeData('create')"
          >新增</el-button
        >
      </div>
      <div class="h-[calc(100%-90px)] p-5px">
        <el-tree
          v-if="treeStandBy"
          ref="tree"
          :data="treeData"
          node-key="id"
          :props="{
            children: 'children',
            label: 'name',
          }"
          highlight-current
          :expand-on-click-node="false"
          @node-click="handleNodeClick"
          :default-expanded-keys="defaultExpandIds"
          :default-expand-all="defaultExpandAll"
          :current-node-key="currentSelectKey"
          v-loading="treeLoading"
        >
          <div
            class="custom-tree-node overflow-hidden w-full flex justify-between items-center"
            slot-scope="{ node, data }"
          >
            <el-tooltip effect="light" :open-delay="400" :content="node.label" placement="top">
              <span class="text-sm flex-1 mr-10px truncate">{{ data.name }}</span>
            </el-tooltip>
            <el-dropdown>
              <span class="el-dropdown-link">
                <i class="iconfont icon-line-moreVertical text-white"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="handleTreeData('create', data)"
                  >新增</el-dropdown-item
                >
                <el-dropdown-item @click.native="handleTreeData('edit', data)"
                  >编辑</el-dropdown-item
                >
                <el-dropdown-item @click.native="removeTreeData(data)">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-tree>
      </div>
      <div class="pt-10px pr-20px text-right border-top-1px border-gray-500">
        <el-button type="primary" size="mini" @click="saveAngle">保存视角</el-button>
      </div>
    </el-card>
    <el-dialog
      :lock-scroll="false"
      :close-on-click-modal="false"
      :title="(treeOperateType === 'create' ? '新增' : '编辑') + '视角'"
      :visible.sync="treeDialog"
      v-dialogDrag
      @close="closeTreeForm"
      width="25%"
    >
      <el-form :model="treeForm" :rules="treeRules" ref="treeFormRef" label-width="80px">
        <el-form-item label="视角名称" prop="name">
          <el-input v-model="treeForm.name" size="small" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer" class="text-center">
        <el-button type="primary" size="small" @click="saveTreeForm" :loading="saveLoading"
          >保存</el-button
        >
        <el-button size="small" @click="closeTreeForm">取消</el-button>
      </div>
    </el-dialog>
    <wiz-upload-file
      :lock-scroll="false"
      v-dialogDrag
      @refreshList="getTreeData()"
      v-if="showUploadExcelDialog"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
      @exportResults="exportResults"
    ></wiz-upload-file>
  </div>
</template>
<script>
import { ViewAngleApi } from '@wiz-api/scene-management'
import { TempFileApi } from '@wiz-api/file-management'
import { isNil, isEmpty, get, forIn } from 'lodash'
import FnMixins from '@/assets/js/fnMixins'
import cloudRender from '../../assets/js/model/index'

const viewAngleApi = new ViewAngleApi()
const tempFileApi = new TempFileApi()

export default {
  name: 'viewAngle',
  mixins: [FnMixins],
  props: ['location', 'player'],
  data() {
    return {
      showUploadExcelDialog: false, // 导入组件显隐
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      treeData: [], // 模型树数据
      treeLoading: false,
      defaultExpandAll: false, // 是否默认展开全部
      defaultExpandIds: [], // 默认展开
      treeStandBy: true, // 分类树显隐
      keyWord: '',
      treeDialog: false,
      treeForm: {
        name: '',
      },
      treeRules: {
        name: { required: true, message: '请输入视角名称', trigger: 'blur' },
      },
      treeOperateType: '',
      saveLoading: false,
      currentTreeData: null,
      currentSelectKey: null, //当前选中节点key
      selectParentId: [], //默认展开的key
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getTreeData()
    })
  },

  computed: {
    loadModelType() {
      return currentEnv.loadModelType || 'documentId'
    },
    sceneId() {
      return this.$route.query.sceneId
    },
  },

  methods: {
    // 下载导入模板
    async exportTemplate() {
      const [err, res] = await viewAngleApi.getImportStepsTemplate()
      // 返回的是文件流
      if (!err) {
        this.downLoadBlob({
          name: '视角导入模板.xlsx',
          data: res,
        })
      }
    },

    // 上传文件
    uploadExcel() {
      this.showUploadExcelDialog = true
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },

    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      forIn({ file }, (value, key) => {
        formData.append('file', value)
      })
      const [err, res] = await viewAngleApi.callImport(this.sceneId, {
        file: formData.get('file'),
      })
      if (!err) {
        this.uploadFileProps.active = 2
        this.uploadFileProps.successCount = res.successCount
        this.uploadFileProps.failureCount = res.failureCount
        // 如需兼容老样式，则resultFile字段为空或者不设置皆可
        this.uploadFileProps.resultFile = res.resultFile
      }
      this.uploadFileProps.btnLoading = false
    },

    // 导出文件
    async exportExcel() {
      this.exportLoading = true
      const [err, res] = await viewAngleApi.callExport(this.sceneId)
      this.exportLoading = false
      if (!err) {
        this.downLoadBlob({
          name: '视角列表.xlsx',
          data: res,
        })
      }
    },

    // 下载导入结果
    async exportResults() {
      const [err, res] = await tempFileApi.download(this.uploadFileProps.resultFile)
      if (!err) {
        this.downLoadBlob({
          name: '视角导入结果.xlsx',
          data: res,
        })
      }
    },

    // 收起、展开全部
    operateTree(bool) {
      this.defaultExpandIds = []
      this.treeStandBy = false
      this.defaultExpandAll = bool
      this.$nextTick(() => {
        this.treeStandBy = true
      })
    },

    // 关闭弹窗
    closeComponent() {
      this.$emit('closeComponent', 'ViewAngle')
    },

    // 获取视角树
    async getTreeData() {
      this.treeLoading = true
      const [err, res] = await viewAngleApi.menuPageQueryList({
        keyWord: this.keyWord || '',
        isQueryAsTree: true,
        sceneId: this.sceneId,
      })
      if (!err && !isNil(res)) {
        this.treeData = res.items
        this.treeStandBy = false
        this.defaultExpandIds = this.selectParentId
        this.$nextTick(() => {
          this.treeStandBy = true
        })
      }
      this.treeLoading = false
    },

    // 视角树的增改操作
    async handleTreeData(type, data) {
      this.currentTreeData = data
      this.treeForm = this.$options.data().treeForm
      if (type !== 'create') {
        this.treeForm.name = data.name
      }
      this.treeOperateType = type
      this.treeDialog = true
    },

    // 保存树表单操作（新增+编辑）
    saveTreeForm() {
      this.$refs.treeFormRef.validate(async (valid) => {
        if (valid) {
          this.saveLoading = true
          // 新增
          if (this.treeOperateType === 'create') {
            const { data: angle } = await cloudRender.Camera.getCurrentCamera(this.player)
            const [err, res] = await viewAngleApi.create({
              body: {
                name: this.treeForm.name,
                parentId: isNil(this.currentTreeData) ? null : this.currentTreeData.id,
                sceneId: this.sceneId,
                angle: JSON.stringify(angle),
              },
            })
            if (!err) {
              this.currentSelectKey = res.id
              if (res.parentId) {
                this.selectParentId = [res.parentId]
              }
              this.$message.success({
                showClose: true,
                message: '新增成功',
              })
              await this.getTreeData()
            }
          } else {
            // 编辑
            const [err, res] = await viewAngleApi.update(this.currentTreeData.id, {
              body: {
                name: this.treeForm.name,
                parentId: this.currentTreeData.parentId,
                sceneId: this.sceneId,
              },
            })
            if (!err && !isNil(res)) {
              this.$message.success({
                showClose: true,
                message: '编辑成功',
              })
              if (res.parentId) {
                this.selectParentId.push(res.parentId)
              }
              await this.getTreeData()
            }
          }
          this.saveLoading = false
          this.closeTreeForm()
        }
      })
    },

    // 关闭树节点操作弹框
    closeTreeForm() {
      this.treeDialog = false
      this.$refs.treeFormRef.resetFields()
    },

    // 删除树节点数据
    removeTreeData(data) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        lockScroll: false,
        type: 'warning',
      })
        .then(async () => {
          const [err, res] = await viewAngleApi.callDelete(data.id)
          if (!err) {
            this.$message.success({
              showClose: true,
              message: '删除成功！',
            })
            await this.getTreeData()
          }
        })
        .catch(() => {})
    },

    // 点击节点
    async handleNodeClick(data) {
      this.currentSelectKey = data.id
      this.treeStandBy = false
      if(data.parentId) {
        this.selectParentId = [data.parentId]
        this.defaultExpandIds = [data.parentId]
      }
      this.$nextTick(() => {
        this.treeStandBy = true
      })
      if (isEmpty(data.angle)) {
        this.$message.warning('未设置视角')
        return
      }
      await cloudRender.Camera.moveCamera(this.player, 'CameraParam', data.angle, 2)
    },

    // 保存视角
    async saveAngle() {
      if (!this.currentSelectKey) return
      const { data: angle } = await cloudRender.Camera.getCurrentCamera(this.player)
      const [err, res] = await viewAngleApi.setAngle({
        body: {
          id: this.currentSelectKey,
          Angle: JSON.stringify(angle),
        },
      })
      if (!err) {
        this.$message.success('保存成功')
        this.getTreeData()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/style/select';
@import '../../assets/style/index';

.angle-mgt {
  background-color: rgba(0, 18, 55, 0.3) !important;
}

::v-deep {
  .el-card {
    &__body {
      padding: 0 !important;
      height: calc(100% - 30px);
      background-color: rgba(24, 41, 72, 0.5) !important;
      border-radius: 2px;
    }
  }

  .el-loading-mask {
    height: 100% !important;
    background-color: rgba(24, 41, 72, 0.8) !important;
  }

  .el-tree {
    height: 100% !important;
  }

  .el-card .el-card__header {
    background: transparent !important;
  }

  .el-button.el-tooltip {
    padding: 0 !important;
    width: 25px !important;
    height: 25px !important;
    line-height: 1 !important;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #fff !important;
  }
}
</style>
